import { Link } from 'react-router-dom';
import type { Product } from '../data/catalog';
import { Money, Stars } from './ui';

export function ProductCard({ product }: { product: Product }) {
  return (
    <Link
      to={`/produkt/${product.slug}`}
      data-product-id={product.id}
      className="group flex flex-col rounded-xl border border-[#26304d] bg-[#141a2e]/70 p-4 transition hover:border-[#4f8cff]"
    >
      <div
        className="mb-3 flex h-28 items-center justify-center rounded-lg text-5xl"
        style={{ background: `linear-gradient(135deg, ${product.color}22, ${product.color}08)` }}
      >
        {product.emoji}
      </div>
      <span className="text-[11px] uppercase tracking-wide text-slate-500">{product.brand}</span>
      <span className="mt-0.5 line-clamp-2 text-[13.5px] font-medium text-slate-100 group-hover:text-white">
        {product.name}
      </span>
      <span className="mt-1">
        <Stars value={product.rating} count={product.reviews} />
      </span>
      <span className="mt-auto flex items-baseline gap-2 pt-3">
        <span className="text-[15px] font-semibold text-white">
          <Money v={product.price} />
        </span>
        {product.listPrice && (
          <span className="text-[12px] text-slate-500 line-through">
            <Money v={product.listPrice} />
          </span>
        )}
      </span>
    </Link>
  );
}
